import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";

import { OnboardingAutoTranslationSettingPage } from "./pages/auto-translation-setting/OnboardingAutoTranslationSettingPage";
import { OnboardingCodeOfConductPage } from "./pages/code-of-conduct/OnboardingCodeOfConductPage";
import { OnboardingGroupsPage } from "./pages/groups/OnboardingGroupsPage";
import { OnboardingHelpCategoriesPage } from "./pages/help-categories/OnboardingHelpCategoriesPage";
import { JoinProjectConnectionPage } from "./pages/join-project-connection/JoinProjectConnectionPage";
import { OnboardingSlidesPage } from "./pages/slides/OnboardingSlidesPage";
import { OnboardingUserProfilePage } from "./pages/user-profile/OnboardingUserProfilePage";
import { onboardingFlowRoutes } from "./routes";

// KEEP this in the actual order of the onboarding flow
export const onboardingFlowRoute = [
  {
    path: onboardingFlowRoutes.slides,
    element: <OnboardingSlidesPage />,
  },
  {
    path: onboardingFlowRoutes.codeOfConduct,
    element: <OnboardingCodeOfConductPage />,
  },
  {
    path: onboardingFlowRoutes.userProfile,
    element: <OnboardingUserProfilePage />,
  },
  {
    path: onboardingFlowRoutes.autoTranslationSetting,
    element: <OnboardingAutoTranslationSettingPage />,
  },
  {
    path: onboardingFlowRoutes.groups,
    element: <OnboardingGroupsPage />,
  },
  {
    path: onboardingFlowRoutes.helpCategories,
    element: <OnboardingHelpCategoriesPage />,
  },
  {
    path: onboardingFlowRoutes.joinProjectConnection,
    element: <JoinProjectConnectionPage />,
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
